import { queryOptions, useQuery } from '@tanstack/react-query'
import { HTTPError } from 'ky'
import type { ResAuth } from '@/shared/types'
import { apiClient } from '@/shared/api/client'

export function authQueryOptions() {
  return queryOptions({
    queryKey: ['auth'],
    queryFn: async (): Promise<ResAuth | null> => {
      try {
        const data = await apiClient.auth.getAuth()
        return {
          user: data.user,
        }
      } catch (error) {
        if (error instanceof HTTPError && error.response.status === 401) {
          return null
        }
        throw error
      }
    },
  })
}

export function useAuthQuery() {
  return useQuery(authQueryOptions())
}
